//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters} from "vuex";

export default {

    name: 'SideBarBlock',

    watch: {

        isOpen: function (newVal, oldVal) {
            if(newVal === oldVal) {
                return
            }

            if(newVal === false) {
                this.clearSidebar()
            }

        },

    },

    computed: {
        ...mapGetters(["companies"]),

        isOpen: {
            get() {
                return this.$store.state.search.isOpen;
            },
            set(value) {
                this.$store.commit("search/isOpen", value);
            },
        },

        currentComponent: {
            get() {
                return this.$store.state.search.currentComponent;
            },
            set(value) {
                this.$store.commit("search/currentComponent", value);
            },
        },

    },
    methods: {
        // Close Side Bar Window
        closewindow() {
            this.isOpen = false;
            this.clearSidebar();
        },
        // add Item To Request Card
        addToCart(company) {
            this.$store.dispatch("search/addItem", company);
        },
        // Clear Sidebar After Close
        clearSidebar() {
            this.$store.dispatch("search/clearSidebar");
            this.currentComponent = undefined
        },
    },
    mounted() {
        this.addToCart,
            this.sidebarCart
    },
};
